export interface Category {
  id: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: "platform-guide",
    name: "平台指南",
    description: "全面了解开云平台各项功能与操作流程，帮助您快速上手使用平台服务。",
    icon: "ri-guide-line",
    articleCount: 12,
  },
  {
    id: "security",
    name: "安全中心",
    description: "关注账户安全与隐私保护，学习如何保障您的平台使用安全。",
    icon: "ri-shield-check-line",
    articleCount: 8,
  },
  {
    id: "latest-news",
    name: "最新动态",
    description: "获取开云平台最新资讯、版本更新与活动通知。",
    icon: "ri-flashlight-line",
    articleCount: 15,
  },
  {
    id: "faq-help",
    name: "常见问题",
    description: "汇集用户常见疑问与详细解答，快速解决您在使用中遇到的问题。",
    icon: "ri-question-answer-line",
    articleCount: 20,
  },
  {
    id: "service-support",
    name: "服务支持",
    description: "了解平台客户服务内容、联系方式与服务流程。",
    icon: "ri-customer-service-2-line",
    articleCount: 6,
  },
  {
    id: "experience",
    name: "体验分享",
    description: "阅读真实用户的使用体验与心得分享。",
    icon: "ri-chat-smile-2-line",
    articleCount: 10,
  },
];